import React from 'react';
import PropTypes from 'prop-types';
import {
  DialogContent,
  DialogActions,
} from '@material-ui/core';
import LoadingButton from '@material-ui/lab/LoadingButton';
import DeleteIcon from '@material-ui/icons/Delete';
import MaterialDialog from '../../atoms/materialDialog/MaterialDialog';
import DialogColorTitle from '../../atoms/dialogColorTitle/DialogColorTitle';
import CancelButton from '../../atoms/cancaelButton/CancelButton';

export default function DeleteConfirmDialog(props) {
  const {
    open,
    procName,
    onClose,
    onDelete,
    loading,
  } = props;

  return (
    <MaterialDialog open={open} onClose={onClose}>
      <DialogColorTitle>{`選択した${procName}の削除`}</DialogColorTitle>
      <DialogContent dividers>{`選択した${procName}を削除します。この操作は元に戻すことができません。`}</DialogContent>
      <DialogActions>
        <CancelButton onClick={onClose}>キャンセル</CancelButton>
        <LoadingButton
          variant="outlined"
          onClick={onDelete}
          loading={loading}
          color="secondary"
          startIcon={<DeleteIcon />}
        >
          削除する
        </LoadingButton>
      </DialogActions>
    </MaterialDialog>
  );
}

DeleteConfirmDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};
